module.exports = __webpack_public_path__ + "static/media/laptop-screen.d0c759f6.jpg";